const LeftIcon = () => {
    return (
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
            <foreignObject x="-27.5" y="-27.5" width="99" height="99">
                <div
                    style={{
                        backdropFilter: 'blur(13.75px)',
                        clipPath: 'url(#bgblur_0_1292_12566_clip_path)',
                        height: '100%',
                        width: '100%',
                    }}
                ></div>
            </foreignObject>
            <path
                data-figma-bg-blur-radius="27.5"
                d="M44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44C34.1503 44 44 34.1503 44 22Z"
                fill="black"
                fillOpacity="0.2"
            />
            <path
                d="M24.4164 28.1696L18.9069 22.66C18.7279 22.481 18.7279 22.1908 18.9069 22.0118L24.4164 16.5023"
                stroke="white"
                strokeWidth="1.83333"
                strokeLinecap="round"
            />
            <defs>
                <clipPath id="bgblur_0_1292_12566_clip_path" transform="translate(27.5 27.5)">
                    <path d="M44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44C34.1503 44 44 34.1503 44 22Z" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default LeftIcon;
